export const destinationBoardTemplates = [
  {
    templateKey: "golden-week-overseas-7d",
    title: "GWで1週間海外旅行",
    description: "春の連休を使って、東京から海外へ。7日間の行き先候補を探します。",
    icon: "earth-americas-solid-full",
    badge: "7 DAYS / OVERSEAS",
    conditions: "東京発・海外・7日間",
  },
  {
    templateKey: "summer-domestic-3d",
    title: "夏休みに2泊3日で国内旅行",
    description: "東京から気軽に出発。夏を楽しむ3日間の国内旅行を考えます。",
    icon: "map-solid-full",
    badge: "3 DAYS / DOMESTIC",
    conditions: "東京発・国内・3日間",
  },
  {
    templateKey: "domestic-quick-trip-2d",
    title: "1泊2日で国内弾丸旅行",
    description: "週末にも収まる短期集中の旅。東京発・2日間で行ける場所を探します。",
    icon: "plane-solid-full",
    badge: "2 DAYS / QUICK TRIP",
    conditions: "東京発・国内・2日間",
  },
];
